// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".folders_dropdown_create_container-module__container--1HWVv{padding:16px;height:350px}@media screen and (max-width: 48em){.folders_dropdown_create_container-module__container--1HWVv{height:auto}}\n", ""]);
// Exports
exports.locals = {
	"container": "folders_dropdown_create_container-module__container--1HWVv"
};
module.exports = exports;
